module.exports = __webpack_public_path__ + "static/media/shape_3.7a683d98.svg";